/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Credit_NotesInputs */

const en_nav_credit_notes = /** @type {(inputs: Nav_Credit_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit notes`)
};

/**
* | output |
* | --- |
* | "Credit notes" |
*
* @param {Nav_Credit_NotesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_credit_notes = /** @type {((inputs?: Nav_Credit_NotesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Credit_NotesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_credit_notes(inputs)
});